// Shared NERC constants

export const DOC_TYPES = [
  { value: "program", label: "Program" },
  { value: "policy", label: "Policy" },
  { value: "plan", label: "Plan" },
  { value: "procedure", label: "Procedure (SOP)" },
  { value: "process", label: "Process" },
];
export const docTypeLabel = (v) => (DOC_TYPES.find((d) => d.value === v)?.label || v);

// Full NERC functional registration list
export const NERC_FUNCTIONS = [
  ["BA", "Balancing Authority"], ["DP", "Distribution Provider"], ["DP-UFLS", "DP — UFLS-only"],
  ["GO", "Generator Owner"], ["GO-2", "Generator Owner (2)"], ["GOP", "Generator Operator"],
  ["GOP-2", "Generator Operator (2)"], ["IA", "Interchange Authority"],
  ["LSE", "Load-Serving Entity"], ["PA", "Planning Authority"], ["PC", "Planning Coordinator"],
  ["PSE", "Purchasing-Selling Entity"], ["RC", "Reliability Coordinator"], ["RP", "Resource Planner"],
  ["RSG", "Reserve Sharing Group"], ["TO", "Transmission Owner"], ["TOP", "Transmission Operator"],
  ["TP", "Transmission Planner"], ["TSP", "Transmission Service Provider"],
  ["CLO", "Computational Load Owner", "future"], ["CLOP", "Computational Load Operator", "future"],
];
export const funcLabel = (c) => {
  const f = NERC_FUNCTIONS.find((x) => x[0] === c);
  return f ? `${c} — ${f[1]}` : c;
};

// NERC Regional Entities (selectable in the Entity Profile). Selecting a region
// brings its region-specific standards (e.g. BAL-001-TRE-2 for TRE) into scope.
export const NERC_REGIONS = [
  ["TRE", "Texas Reliability Entity"],
  ["RF", "ReliabilityFirst"],
  ["SERC", "SERC Reliability Corporation"],
  ["WECC", "Western Electricity Coordinating Council"],
  ["NPCC", "Northeast Power Coordinating Council"],
  ["MRO", "Midwest Reliability Organization"],
];

// Region tokens recognized inside a standard id, normalized to the selectable code.
const REGION_TOKENS = { TRE: "TRE", RF: "RF", RFC: "RF", SERC: "SERC", WECC: "WECC", NPCC: "NPCC", MRO: "MRO", FRCC: "FRCC", SPP: "SPP", SPPRE: "SPP" };

// Region code embedded in a standard id (BAL-001-TRE-2 -> "TRE"), or null if continent-wide.
export const standardRegion = (standardId) => {
  for (const seg of String(standardId || "").toUpperCase().split("-")) {
    if (REGION_TOKENS[seg]) return REGION_TOKENS[seg];
  }
  return null;
};
